import { css } from "glamor";
import React from "react";
import { spacing, uiColors } from "../library/theme";
import QuestionNavigationContainer from "./QuestionNavigationContainer";
import QuestionRepliesListContainer from "./QuestionRepliesListContainer";
import QuestionTitle from "./QuestionTitle";
import QuestionComments from "./QuestionComments";

const commentClass = css({
  margin: `${spacing.m} 0`,
  paddingBottom: spacing.m,
  borderBottom: `1px solid ${uiColors.border}`,
});

export default function QuestionV1(props) {
  const {
    question,
    replied,
    answered,
    readOnly,
    showMockAnswer,
    lesson,
    selectedReply,
    mockPreferences,
    routePrefix,
  } = props;

  const questionCommentClass = css(
    commentClass,
    readOnly && {
      borderBottom: "none",
      paddingBottom: "0",
      marginBottom: "0",
    }
  );

  const hasComments =
    question?.vimeoUrl ||
    question?.scaleupUrl ||
    question?.commentVideoUrl ||
    question?.commentText ||
    question?.commentFileUrl;

  const showQuestionComments =
    hasComments &&
    (
      readOnly ||
      (answered && lesson) ||
      (answered && showMockAnswer && mockPreferences?.showVideo)
    );

  return question ? (
    <div>
      <QuestionTitle {...props} displayIndex={props.displayIndex} />
      <QuestionRepliesListContainer
        questionId={question.id}
        replied={lesson ? selectedReply : replied}
        readOnly={readOnly}
        lesson={lesson}
      />
      {!readOnly && (
        <QuestionNavigationContainer
          lesson={lesson}
          routePrefix={routePrefix}
        />
      )}
      {showQuestionComments && (
        <div className={questionCommentClass}>
          <QuestionComments question={question} />
        </div>
      )}
    </div>
  ) : null;
}
